export const getUserIANA = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
